import { useEffect, useState } from "react";
import type { Stats } from "@tih/shared";
import { PUBLIC_STATS_REFRESH_MS } from "@tih/shared";
import { fetchStats } from "../api/client";

/** Polls `/api/stats`; server caches YouTube/simulated numbers for the same interval. */
export function useLiveStats(intervalMs = PUBLIC_STATS_REFRESH_MS): Stats | null {
  const [stats, setStats] = useState<Stats | null>(null);
  useEffect(() => {
    let cancelled = false;
    let timer: number | undefined;

    async function poll() {
      try {
        const next = await fetchStats();
        if (!cancelled) setStats(next);
      } catch {
        // swallow; will retry on next interval
      } finally {
        if (!cancelled) timer = window.setTimeout(poll, intervalMs);
      }
    }
    poll();
    return () => {
      cancelled = true;
      if (timer) window.clearTimeout(timer);
    };
  }, [intervalMs]);
  return stats;
}
